import { SendEventDisbursement, sendException } from 'helpers/analytics';
import { getChannelContextCode } from 'helpers/Utility';
import { setError } from 'store/actions/auth';

export const handleErrorEkycVerificationV3 = (dispatch, getState, err) => {
  if (err.toString().includes('Network Error')) {
    dispatch(setError('connection'));
    return;
  }

  const channelCode = getChannelContextCode(err, 'channel-context');

  const errorMap = {
    44001: {
      key: 'limit_usage',
      action: 'Daily limit usage privy'
    },
    44401: {
      key: 'data_not_found',
      action: 'Certified Issue'
    }
  };

  const mappedError = errorMap[channelCode];

  if (mappedError) {
    dispatch(setError(mappedError.key));
    SendEventDisbursement({
      action: mappedError.action,
      isSecondApply: getState().loanApply.isSecondApply
    });
    sendException({
      desc: mappedError.action,
      fatal: 'true'
    });
    return;
  }

  dispatch(setError('system'));
};
